import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import { scene_data, scene_orders } from '@/data';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'whhPersist', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    scene_order: null,
    key: null,
  },
  getters: {
    scene_ids: (state) => {
      if (state.scene_order) {
        return scene_orders[state.scene_order];
      } else {
        return [];
      }
    },
    scenes: (state) => {
      if (state.scene_order) {
        return scene_orders[state.scene_order].map(x => scene_data[x]);
      } else {
        return [];
      }
    }
  },
  mutations: {
    scene_order (state, order) {
      // mutate state
      // console.log("mutate scene_order:", order);
      if (Object.prototype.hasOwnProperty.call(scene_orders, order)) {
        // console.log("committing", order);
        state.scene_order = order;
      }
    },
    set_key (state, key) {
      state.key = key;
    }
  },
  actions: {
  },
  modules: {
  }
})
